import React from 'react';
import PropTypes from 'prop-types';
import { control } from 'react-validation';

class Input extends React.Component {
  constructor(props) {
    super(props);

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      showError: true,
    };
  }

  onFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
    if (this.props.handleOnFocus) {
      this.props.handleOnFocus(e);
    }
  }

  onBlur(e) {
    if (this.props.isChanged && this.props.error) {
      this.props.onShowError();
      this.setState({
        showError: true,
      });
    }
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
    if (this.props.handleOnBlur) {
      this.props.handleOnBlur(e);
    }
  }

  onChange(e) {
    this.props.onHideError();
    this.setState({
      showError: false,
    });
    if (this.props.onChange) {
      this.props.onChange(e);
    }
    if (this.props.handleOnChange) {
      this.props.handleOnChange(e);
    }
  }

  render() {
    const {
      error,
      isChanged,
      isUsed,
      onShowError,
      onHideError,
      handleOnBlur,
      handleOnFocus,
      handleOnChange,
      ...props
    } = this.props;

    return (
      <div>
        <input
          tabIndex={0}
          {...props}
          {...(this.state.showError && isUsed && isChanged && error ? { className: `is-invalid-input ${props.className}` } : { className: props.className })}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
        { this.state.showError && isUsed && isChanged && error }
      </div>
    );
  }
}

Input.defaultProps = {
  children: null,
  error: null,
  isChanged: false,
  isUsed: false,
  onShowError: () => {},
  onHideError: () => {},
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
  handleOnBlur: () => {},
  handleOnFocus: () => {},
  handleOnChange: () => {},
};

Input.propTypes = {
  children: PropTypes.node,
  error: PropTypes.node,
  isChanged: PropTypes.bool,
  isUsed: PropTypes.bool,
  onShowError: PropTypes.func,
  onHideError: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  handleOnBlur: PropTypes.func,
  handleOnFocus: PropTypes.func,
  handleOnChange: PropTypes.func,
};

const ControlInput = control(Input);
export default ControlInput;



// WEBPACK FOOTER //
// ./src-react/Validation/Input/index.jsx